"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollable = void 0;
const react_1 = __importDefault(require("react"));
exports.Scrollable = react_1.default.forwardRef(({ className, children }, ref) => {
    return (react_1.default.createElement("div", { ref: ref, className: `h-full w-full custom-scrollbar overflow-y-scroll mb-12 z-10 ${className}` }, children));
});
//# sourceMappingURL=Scrollable.js.map